module.exports = __webpack_public_path__ + "img/et-statuario.b774d026.jpg";